import gql from "graphql-tag";

// GraphQL mutation for registering/updating identity provider
export const REGISTER_IDENTITY_PROVIDER = gql`
    mutation registerIdentityProvider(
        $metadataSelection: String!
        $samlAttributeEmail: String!
        $providerType: SupportedIdentityProviderTypeType!
        $metadataDocumentEndpointURL: String
        $metadataCertificate: String
    ) {
        registerIdentityProvider(
            metadataSelection: $metadataSelection
            samlAttributeEmail: $samlAttributeEmail
            providerType: $providerType
            metadataDocumentEndpointURL: $metadataDocumentEndpointURL
            metadataCertificate: $metadataCertificate
        ) {
            sso {
                enabled
                federatedIDPs {
                    providerType
                    providerDetails
                    attributeMappings
                }
            }
        }
    }
`;

// GraphQL mutation for enable and disable sso service
export const ENABLE_OR_DISABLE_SSO = gql`
    mutation enableOrDisableSSO($enableSSO: Boolean) {
        enableOrDisableSSO(enableSSO: $enableSSO) {
            sso {
                enabled
            }
        }
    }
`;
